import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { authFB,storage } from '../../../helpers/Firebase';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
    SUPPLIER_COM_INFRA_SUPPLIER,
    SUPPLIER_COM_INFRA_TYPE,

    
    SUPPLIER_COMMUNICATION_INFRA_LIST,
    SUPPLIER_COMMUNICATION_INFRA_ADD,
    SUPPLIER_COMMUNICATION_INFRA_EDIT,
    SUPPLIER_COMMUNICATION_INFRA_UPLOAD_SET
} from "../../actions";

import {
    SupplierComInfraSupplierSuccess,
    SupplierComInfraSupplierError,
    SupplierComInfraTypeSuccess,
    SupplierComInfraTypeError,


    
    SupplierCommunicationInfraListSuccess,
    SupplierCommunicationInfraListError,
    SupplierCommunicationInfraAddSuccess,
    SupplierCommunicationInfraAddError,
    SupplierCommunicationInfraEditSuccess,
    SupplierCommunicationInfraEditError,
    SupplierCommunicationInfraUploadSetSuccess,
    SupplierCommunicationInfraUploadSetError
} from '../../actions';

export function* watchSupplierComInfraSupplier() {
    yield takeEvery(SUPPLIER_COM_INFRA_SUPPLIER, onSupplierComInfraSupplier);
}

export function* watchSupplierComInfraType() {
    yield takeEvery(SUPPLIER_COM_INFRA_TYPE, onSupplierComInfraType);
}



export function* watchSupplierCommunicationInfraList() {
    yield takeEvery(SUPPLIER_COMMUNICATION_INFRA_LIST, onSupplierCommunicationInfraList);
}

export function* watchSupplierCommunicationInfraAdd() {
    yield takeEvery(SUPPLIER_COMMUNICATION_INFRA_ADD, onSupplierCommunicationInfraAdd);
}

export function* watchSupplierCommunicationInfraEdit() {
    yield takeEvery(SUPPLIER_COMMUNICATION_INFRA_EDIT, onSupplierCommunicationInfraEdit);
}

export function* watchSupplierCommunicationInfraUploadSet() {
    yield takeEvery(SUPPLIER_COMMUNICATION_INFRA_UPLOAD_SET, onSupplierCommunicationInfraUploadSet);
}
function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onSupplierComInfraSupplierAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'supplierCommunicationInfra/supplier', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onSupplierComInfraTypeAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'supplierCommunicationInfra/communicationtype', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};








const onSupplierCommunicationInfraListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'supplierCommunicationInfra/communicationlist', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
}

const onSupplierCommunicationInfraAddAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'supplierCommunicationInfra/add', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { message: true, data: response };
};

const onSupplierCommunicationInfraEditAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'supplierCommunicationInfra/edit', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { message: true, data: response };
};

const onSupplierCommunicationInfraUploadSetAsync = async (file) => {
    var storageRef = storage.ref();
    let filename = file.name;
    return await new Promise((success, reject) => {
        var uploadTask = storageRef.child(storagePath + '/communicationdocsinfra/' + filename).put(file);
        uploadTask.on('state_changed',
            function (snapshot) {
                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
            },
            function (error) {
                reject({ name: filename, original: file.name, message: error.code, url: '', type: file.type, size: file.size, path: 'answerforms/' })
            },
            function () {
                uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                    success({ message: 'success', name: filename, original: file.name, url: downloadURL });
                });
            });
    });
};

function* onSupplierComInfraSupplier(data) {
    try {
        const response = yield call(onSupplierComInfraSupplierAsync, data.payload);
        yield put(SupplierComInfraSupplierSuccess(response.data));
    } catch (error) {
        yield put(SupplierComInfraSupplierError(error));
    }
}

function* onSupplierComInfraType(data) {
    try {
        const response = yield call(onSupplierComInfraTypeAsync, data.payload);
        yield put(SupplierComInfraTypeSuccess(response.data));
    } catch (error) {
        yield put(SupplierComInfraTypeError(error));
    }
}






function* onSupplierCommunicationInfraList(data) {
    try {
        const response = yield call(onSupplierCommunicationInfraListAsync, data.payload);
        yield put(SupplierCommunicationInfraListSuccess(response.data));
    } catch (error) {
        yield put(SupplierCommunicationInfraListError(error));
    }
}

function* onSupplierCommunicationInfraAdd(data) {
    try {
        const response = yield call(onSupplierCommunicationInfraAddAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(SupplierCommunicationInfraAddSuccess(response.data));
    } catch (error) {
        yield put(SupplierCommunicationInfraAddError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onSupplierCommunicationInfraEdit(data) {
    try {
        const response = yield call(onSupplierCommunicationInfraEditAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(SupplierCommunicationInfraEditSuccess(response.data));
    } catch (error) {
        yield put(SupplierCommunicationInfraEditError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}


function* onSupplierCommunicationInfraUploadSet({ payload }) {
    const { file } = payload;
    try {
        const response = yield call(onSupplierCommunicationInfraUploadSetAsync, file);
        console.log("response" + JSON.stringify(response));
        if (response.message === 'success') {

            yield put(SupplierCommunicationInfraUploadSetSuccess(response));

        }
        else {
            yield put(SupplierCommunicationInfraUploadSetError(response));
        }
    } catch (error) {
        yield put(SupplierCommunicationInfraUploadSetError({ name: '', original: file.name, message: error, url: '', path: '' }))
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchSupplierComInfraSupplier), 
        fork(watchSupplierComInfraType), 


        fork(watchSupplierCommunicationInfraList),
        fork(watchSupplierCommunicationInfraAdd),
        fork(watchSupplierCommunicationInfraEdit),
        fork(watchSupplierCommunicationInfraUploadSet)
    ]);
}